import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import parse from 'html-react-parser';


function SongPlayModal(props) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
/*
  if (!props.songId) {
    return null; // If url is empty, don't render anything
  }
*/
  return (
    <>
    
    {
      
      props.classvalue ? (
        <i class={props.classvalue} onClick={handleShow}></i>
        
      ) : (
        
        <Button variant="primary" onClick={handleShow}>
          {props.linkText}   
        </Button>
      )
    }
        

      <Modal 
        show={showModal} 
        onHide={handleClose} 
        size="lg"
        centered
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body> 

        <div>
        
        <iframe
              src={`https://open.spotify.com/embed/track/${props.songId}`}
              width="100%"
              height="352"
              frameBorder="0"
              allowFullScreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
        </div>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default SongPlayModal;
